const types = {
  SET_LOADING_STATUS: 'SET_LOADING_STATUS',
  SET_WEB_SHEETS_DATA: 'SET_WEB_SHEETS_DATA',
};

export default types;
